async function initializeMsw() {
  const { worker } = await import('@/api/msw/browser');

  await worker.start({
    onUnhandledRequest: 'bypass',
    quiet: true,
  });
}

export async function bootstrapApp() {
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW === 'true') {
    await initializeMsw();
  }
}
